import { render, staticRenderFns } from "./mdChart.vue?vue&type=template&id=4823d9f0&scoped=true&"
import script from "./mdChart.vue?vue&type=script&lang=js&"
export * from "./mdChart.vue?vue&type=script&lang=js&"
import style0 from "./mdChart.vue?vue&type=style&index=0&id=4823d9f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4823d9f0",
  null
  
)

export default component.exports